import React from "react";

// Small reusable confirm modal. Uses the global paper/ink/brand tokens so it
// works on both the token-styled pages (ProjectDashboard) and the daisyUI pages
// (MonitoringSetupPage).
const ConfirmDialog: React.FC<{
  open: boolean;
  title: string;
  body?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({
  open,
  title,
  body,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-scrim/40" onClick={busy ? undefined : onCancel} />
      <div className="relative w-full max-w-md rounded-2xl bg-surface p-6 shadow-2xl">
        <h3 className="mb-2 text-lg font-semibold text-ink">{title}</h3>
        {body && <div className="mb-5 text-sm text-ink-muted">{body}</div>}
        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            disabled={busy}
            className="rounded-lg px-4 py-2 text-sm font-medium text-ink-muted hover:bg-paper-100 disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={busy}
            className={`rounded-lg px-4 py-2 text-sm font-medium text-on-brand disabled:opacity-50 ${
              danger ? "bg-bad hover:bg-bad/90" : "bg-brand-500 hover:bg-brand-600"
            }`}
          >
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
